import { render, staticRenderFns } from "./ShopClaim.vue?vue&type=template&id=ad458756&scoped=true&"
import script from "./ShopClaim.vue?vue&type=script&lang=js&"
export * from "./ShopClaim.vue?vue&type=script&lang=js&"
import style0 from "./ShopClaim.vue?vue&type=style&index=0&id=ad458756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad458756",
  null
  
)

component.options.__file = "ShopClaim.vue"
export default component.exports